// Lightweight click-to-call tracking. Attaches a single delegated click
// listener to document — fires a non-blocking beacon to the backend when a
// user clicks any <a href="tel:..."> anywhere on the site.
//
// - No cookies, no third-party pixels.
// - Uses navigator.sendBeacon when available so the request survives page
//   unload (mobile "click to call" typically leaves the page immediately).
// - Falls back to fetch({keepalive:true}) on browsers without sendBeacon.
import { API } from "./api";
import { getAttribution } from "./attribution";

const ENDPOINT = `${API}/events/phone-click`;

function deriveSource(anchor) {
  // Prefer an explicit data-testid, fall back to nearest section id or "unknown".
  const testid = anchor.getAttribute("data-testid");
  if (testid) return testid;
  const section = anchor.closest("section, footer, header");
  if (section?.id) return section.id;
  const path = window.location.pathname.replace(/\//g, "-").replace(/^-|-$/g, "");
  return path || "landing";
}

function sendCallEvent(source) {
  const attr = getAttribution();
  const body = JSON.stringify({
    source,
    path: window.location.pathname,
    utm_source: attr.utm_source || null,
    utm_medium: attr.utm_medium || null,
    utm_campaign: attr.utm_campaign || null,
    utm_term: attr.utm_term || null,
    utm_content: attr.utm_content || null,
    referrer: attr.referrer || null,
  });
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(ENDPOINT, blob);
      return;
    }
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (err) {
    // Never block the outbound call
    console.debug("call tracking failed:", err);
  }
}

let installed = false;
export function installCallTracking() {
  if (installed || typeof document === "undefined") return;
  installed = true;
  document.addEventListener(
    "click",
    (e) => {
      const anchor = e.target?.closest?.('a[href^="tel:"]');
      if (!anchor) return;
      sendCallEvent(deriveSource(anchor));
    },
    { capture: true, passive: true }
  );
}
